import { Routes } from '@angular/router';

import { ClientConfigProductName, routeData } from '@frontend/vanilla/core';

export const MOKABINGO_INTERNAL_ROUTES: Routes = [
    {
        path: '',
        loadComponent: () => import('./Home/homelobby/homelobby.component').then((c) => c.HomelobbyComponent),
        data: routeData({ allowAnonymous: true }),
    },
    {
        path: 'nickname',
        loadComponent: () => import('./player-nickname/player-nickname.component').then((c) => c.PlayerNicknameComponent),
        data: routeData({ allowAnonymous: true }),
    },
    {
        path: 'unifiedgamelaunch/:roomId',
        loadComponent: () => import('./shared/unified-game-launch/unified-game-launch.component').then((c) => c.UnifiedGameLaunchComponent),
        data: routeData({ allowAnonymous: true }),
    },
    {
        path: 'bingohalls',
        loadComponent: () => import('./bingohalls/bingohalls.component').then((c) => c.BingohallsComponent),
        data: routeData({ allowAnonymous: true }),
    },
    {
        path: 'gamelogs',
        loadComponent: () => import('./gamelogs/game-log.component').then((c) => c.GameLogComponent),
        data: routeData({ allowAuthorized: true, authorized: true }),
    },
    {
        path: 'palimpset',
        loadComponent: () => import('./schedule-page/schedule-page.component').then((c) => c.SchedulePageComponent),
        data: routeData({ allowAnonymous: true }),
    },
    {
        path: 'chatwin',
        loadComponent: () => import('./chatnwin/chatnwin.component').then((c) => c.ChatnwinComponent),
        data: routeData({ allowAnonymous: true }),
    },
    {
        path: 'rules',
        loadComponent: () => import('./rules/rules.component').then((c) => c.RulesComponent),
        data: { highlightNavKey: 'rules' },
    },
    {
        path: 'discover',
        loadComponent: () => import('./discover/discover.component').then((c) => c.DiscoverComponent),
        data: { highlightNavKey: 'discover' },
    },
    {
        path: 'premi',
        loadComponent: () => import('./discover/discover.component').then((c) => c.DiscoverComponent),
        data: { highlightNavKey: 'premi' },
    },
    {
        path: 'come-si-gioca',
        loadComponent: () => import('./rules/rules.component').then((c) => c.RulesComponent),
        data: { highlightNavKey: 'come-si-gioca' },
    },
    {
        path: 'winners',
        loadComponent: () => import('./winners/winners.component').then((c) => c.WinnersComponent),
        data: routeData({ allowAnonymous: true }),
    },
    {
        path: 'leaderboard',
        loadComponent: () => import('./LeaderBoard/leader-board.component').then((c) => c.LeaderBoardComponent),
        data: routeData({ allowAnonymous: true }),
    },
    {
        path: 'newleaderboard',
        loadComponent: () => import('./NewLeaderBoard/new-leader-board.component').then((c) => c.NewLeaderBoardComponent),
        data: routeData({ allowAnonymous: true }),
    },
    {
        path: 'p',
        loadChildren: () => import('@frontend/vanilla/features/public-page').then((m) => m.ROUTES),
        data: {
            publicPageRoot: 'MokaBingo/PublicPages/',
            product: ClientConfigProductName.MOKABINGO,
        },
    },
];
